import { useSelectedOrganization } from './use-organizations';

const useIsMMTOrg = () => {
  const currentOrg = useSelectedOrganization();
  // return function that returns true if the current org is MMT
  return () => currentOrg?.orgId === 'org_K2epLHz3py';
};

export default useIsMMTOrg;
